import { SKIP_RENDER } from '@mediashop/app/constants/semanticConstants';
import useNativeShare from '@mediashop/app/hooks/useNativeShare';
import Icon from '@mediashop/base/pattern/atom/Icon';
import StarRating from '@mediashop/base/pattern/atom/StarRating';
import Modal from '@mediashop/base/pattern/molecule/Modal';
import SocialShare from '@mediashop/base/pattern/molecule/SocialShare';
import classNames from 'classnames';
import { useState } from 'react';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import {
    componentName as contentNavigationComponentName,
    CONTENT_NAVIGATION_HEIGHT,
} from '@mediashop/catalog-base/pattern/molecule/ContentNavigation/ContentNavigation';
import { ProductDetailsHeaderProps } from './index';
import useSiteName from '@mediashop/app/hooks/useSiteName';

const componentName = 'product-details-header';

const ProductDetailsHeader = ({
    className,
    title,
    claim,
    stars,
    reviewCount,
}: ProductDetailsHeaderProps): JSX.Element => {
    const [canShare] = useNativeShare();
    const shareIsActive = false;
    const [showShareModal, setShowShareModal] = useState(false);
    const intl = useIntl();
    const shopName = useSiteName();

    const handleOnStars = () => {
        const reviewElement = document.getElementById('ratings');
        const ratingItems = document.getElementsByClassName('ratings-item');
        const contentNavigation = document.querySelector(`.${contentNavigationComponentName}`);
        let scrollPosition = reviewElement?.parentElement?.offsetTop ?? 0;

        if (contentNavigation) {
            scrollPosition -= CONTENT_NAVIGATION_HEIGHT;
        }

        window.scrollTo({ top: scrollPosition, behavior: 'smooth' });

        if (ratingItems.length === 0) {
            reviewElement?.click();
        }
    };

    return (
        <div className={classNames(componentName, className)}>
            <div className={`${componentName}__title-wrapper`}>
                <h1 className={`${componentName}__title title-h1`}>{title}</h1>
                {canShare && shareIsActive && (
                    <span onClick={() => setShowShareModal(!showShareModal)}>
                        <Icon name="Share" />
                    </span>
                )}
            </div>
            <Modal isOpen={showShareModal} onRequestClose={() => setShowShareModal(false)}>
                <SocialShare
                    background="default"
                    facebook={false}
                    twitter={false}
                    whatsapp={false}
                    nativeShare
                    fullWidth={false}
                    shareText={intl.formatMessage({ id: 'product.socialMediaShareHeadline' }, { shopName })}
                    shareHeadline={intl.formatMessage({ id: 'product.socialMediaShareText' })}
                />
            </Modal>
            <div className={`${componentName}__subtitle`}>
                <h2>{claim}</h2>
            </div>
            {stars > 0 && reviewCount > 0 ? (
                <div className={`${componentName}__ratings-holder`} onClick={() => handleOnStars()}>
                    <StarRating
                        className={`${componentName}__rating`}
                        rating={stars}
                        ratingText={
                            <span className={`${componentName}__review-count`}>
                                <FormattedMessage
                                    id="product.totalReviews"
                                    values={{
                                        count: reviewCount,
                                        formattedCount: <FormattedNumber value={reviewCount} />,
                                    }}
                                />
                            </span>
                        }
                    />
                </div>
            ) : (
                SKIP_RENDER
            )}
        </div>
    );
};

export default ProductDetailsHeader;
